import type { ThemeDefinition } from 'vuetify';

/**
 * Identité Monaco Taxi.
 *
 * Reprend la charte de la borne : le rouge du drapeau monégasque sur fond blanc,
 * rehaussé d'un or discret pour les accents. Volontairement sobre et très
 * contrasté — la borne est lue debout, à un mètre, parfois en plein soleil dans
 * un hall vitré.
 */
export const MONACO_RED = '#C8102E';
export const MONACO_RED_DARK = '#9B0C23';
export const MONACO_GOLD = '#B99A5B';

export const monacoLight: ThemeDefinition = {
	dark: false,
	colors: {
		background: '#F7F7F9',
		surface: '#FFFFFF',
		'surface-bright': '#FFFFFF',
		'surface-variant': '#F1F1F4',
		'on-surface-variant': '#2B2B2F',
		primary: MONACO_RED,
		'primary-darken-1': MONACO_RED_DARK,
		secondary: '#1F2933',
		accent: MONACO_GOLD,
		error: '#D32F2F',
		info: '#2A6EBB',
		success: '#2E7D32',
		warning: '#ED6C02',
		// Couleurs métier : reprises telles quelles par les pastilles de statut,
		// pour que chauffeur, client et back-office parlent le même langage visuel.
		available: '#2E7D32',
		searching: '#ED6C02',
		enroute: '#2A6EBB',
		onboard: '#6A1B9A',
		offline: '#78909C',
	},
	variables: {
		'border-color': '#E0E0E5',
		'border-opacity': 1,
	},
};

/**
 * Thème sombre.
 *
 * Indispensable en mode conduite : l'application chauffeur reste allumée en
 * continu, y compris de nuit, sur un support de pare-brise.
 */
export const monacoDark: ThemeDefinition = {
	dark: true,
	colors: {
		background: '#121214',
		surface: '#1C1C20',
		'surface-bright': '#2A2A30',
		'surface-variant': '#26262C',
		'on-surface-variant': '#EDEDF0',
		primary: '#E63950',
		'primary-darken-1': MONACO_RED,
		secondary: '#C9D1D9',
		accent: MONACO_GOLD,
		error: '#EF5350',
		info: '#64B5F6',
		success: '#66BB6A',
		warning: '#FFA726',
		available: '#66BB6A',
		searching: '#FFA726',
		enroute: '#64B5F6',
		onboard: '#BA68C8',
		offline: '#78909C',
	},
	variables: {
		'border-color': '#33333A',
		'border-opacity': 1,
	},
};

/**
 * Thème borne.
 *
 * Même palette, mais des cibles tactiles nettement plus grandes : on interagit
 * debout, avec un doigt, souvent des bagages à la main.
 */
export const monacoKiosk: ThemeDefinition = {
	...monacoLight,
	colors: {
		...monacoLight.colors,
		background: '#FFFFFF',
	},
};

export const monacoDefaults = {
	VBtn: { rounded: 'lg', elevation: 0, height: 48 },
	VCard: { rounded: 'lg' },
	VTextField: { variant: 'outlined' as const, density: 'comfortable' as const },
	VSelect: { variant: 'outlined' as const, density: 'comfortable' as const },
	VTextarea: { variant: 'outlined' as const },
};

